import { useState } from 'react';
import { IAnnouncementsResponse } from '@kattana-io/common';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import placeholder from './images/placeholder.svg';

interface ISliderCardProps {
  card: IAnnouncementsResponse;
}

const SliderCard = ({ card }: ISliderCardProps) => {
  const [error, setError] = useState(false);

  return (
    <a
      href={card?.link}
      target='_blank'
      rel='noreferrer'
      className='news_block__card'
    >
      <Text
        size={14}
        className='text--grey-200 text--weight-600 news_block__card__title'
      >
        {card.title}
      </Text>
      {error || !card.image_url ? (
        <Image size='l' src={placeholder} className='news_block__image' />
      ) : (
        <Image
          size='l'
          src={card.image_url}
          className='news_block__image'
          onError={() => {
            setError(true);
          }}
        />
      )}
      <Text
        size={10}
        className='news_block__card__text text--grey-200 text--weight-600'
      >
        {card.text}
      </Text>
    </a>
  );
};

export default SliderCard;
